/**
 * Show and hides blockeditor's toolbar
 *
 * @param {any} model - tiny editor's model (Block Model)
 */

import {
  styleNames,
  serializeDataInline,
  serializeLinkDataInline,
} from './dataInline'

const HEADERS_LIST = ['h1', 'h2', 'h3', 'h4']
const isHeader = (el) => {
  const tagName = el.tagName.toLowerCase()
  return HEADERS_LIST.includes(tagName)
}

export const getPropertyValue = (computedStyles, styleName) => {
  if (styleName === 'padding') {
    const top = computedStyles.getPropertyValue(`${styleName}-top`)
    const right = computedStyles.getPropertyValue(`${styleName}-right`)
    const bottom = computedStyles.getPropertyValue(`${styleName}-bottom`)
    const left = computedStyles.getPropertyValue(`${styleName}-left`)
    if (top === right && top === bottom && top === left) {
      return `${top}`
    } else if (top === bottom && right === left) {
      return `${top} ${right}`
    } else if (top !== bottom && right === left) {
      return `${top} ${right} ${bottom}`
    }
    return `${top} ${right} ${bottom} ${left}`
  }
  return computedStyles.getPropertyValue(styleName)
}

const readStyles = (el) => {
  const computedStyles = window.getComputedStyle(el, null)

  const styles = styleNames
    .map((styleName) => ({
      [styleName]: getPropertyValue(computedStyles, styleName),
    }))
    .reduce((result, current) => ({ ...result, ...current }), {})

  return serializeDataInline(styles)
}

export const setComputedStyles = (elements, globalSettings) => {
  Array.prototype.forEach.call(elements, (el) => {
    el.setAttribute(
      'data-inline',
      readStyles(el) +
        setLineHeight(el, globalSettings) +
        setMargin(el, globalSettings)
    )

    if (el.tagName.toLowerCase() === 'p') {
      // Read the computed value rather than searching the serialised string:
      // how that string is spaced is not this check's business.
      const textAlign = window
        .getComputedStyle(el, null)
        .getPropertyValue('text-align')
      if (textAlign === 'right') {
        el.classList.add('mobile-align-left')
      } else {
        el.classList.remove('mobile-align-left')
      }
    }

    const aTags = el.getElementsByTagName('a')

    Array.prototype.forEach.call(aTags, (link) => {
      const styles = window.getComputedStyle(link, null)
      link.setAttribute('data-inline', serializeLinkDataInline(styles.color))
    })
  })
}

export const setMargin = (el, globalSettings) => {
  return ';margin: 0 0 10px'
}

export const setLineHeight = (el, globalSettings) => {
  const lineHeight = isHeader(el)
    ? globalSettings.headings_lineHeight
    : globalSettings.normalText_lineHeight
  if (!lineHeight) {
    return ''
  }
  return `;line-height:${parseInt(
    +lineHeight * 100,
    10
  )}%; line-height: ${lineHeight}`
}

export default function applyComputedStyles(model, item) {
  tinymce.PluginManager.add('computedstyles', function (editor, url) {
    const applyStylesToContent = () => {
      // Get ALL block-level elements, not just direct children
      // This ensures nested paragraphs also get data-inline attributes
      const body = editor.getBody()
      const blockElements = body.querySelectorAll('p, h1, h2, h3, h4, ul, ol')
      setComputedStyles(blockElements, item.settings.values)
    }

    // Apply styles when saving content
    editor.on('SaveContent', applyStylesToContent)

    // Apply styles after paste to ensure pasted content gets data-inline attributes
    editor.on('PastePostProcess', function (ev) {
      // Small delay to ensure TinyMCE has finished processing the paste
      setTimeout(() => {
        applyStylesToContent()
      }, 0)
    })
  })
}
